import { styled } from "@mui/material";

export const SidebarList = styled("ul")({
  paddingLeft: "0",
  listStyle: "none",
  "& li": { fontSize: "36pt" },
});
